import React, { useEffect } from 'react';
import { SubPageShell } from '../App';
import { allStoreProducts, bundleProduct, cyberProducts } from '../mock';
import { ProductCard } from '../components/StoreSection';
import { BrandMono, CyberChip, TickList, ContactPromptCard } from '../components/SharedUI';
import { ShoppingBag, Cpu, Sparkles } from 'lucide-react';

export default function StorePage() {
  useEffect(() => {
  window.scrollTo({ top: 0, behavior: 'auto' });

  setTimeout(() => {
    document.querySelectorAll('.reveal').forEach((el) => {
      el.classList.add('in');
    });
  }, 100);
}, []);

  const goContact = () => {
    window.location.assign('/#contact');
  };

  return (
    <SubPageShell kicker="05 — Full Store" title={<>Premium tools, half the price.</>}>
      <div className="section" style={{ paddingTop: 40 }}>
        <p
          style={{
            color: 'rgba(245,245,245,0.6)',
            maxWidth: 720,
            fontSize: 16,
            lineHeight: 1.7,
            marginTop: 0,
          }}
        >
          Genuine subscriptions, gaming accounts, and creative tools at around 50% of
          retail. Every request is hand-fulfilled &mdash; tap any card to send the request,
          and I&apos;ll DM you the access details once it&apos;s ready.
        </p>

        {/* Featured pack */}
        <div
          className="glass-card twocol"
          style={{
            marginTop: 32,
            padding: 36,
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1.2fr)',
            gap: 36,
            alignItems: 'center',
          }}
        >
          <div>
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                padding: '6px 12px',
                borderRadius: 999,
                background: 'rgba(245,245,245,0.08)',
                border: '1px solid rgba(245,245,245,0.12)',
                marginBottom: 14,
              }}
            >
              <Sparkles size={12} />
              <span className="mono" style={{ fontSize: 10, letterSpacing: '0.3em', color: 'rgba(245,245,245,0.7)' }}>
                BEST VALUE
              </span>
            </div>
            <h2 style={{ fontFamily: 'Space Grotesk, sans-serif', fontSize: 'clamp(28px, 3.4vw, 40px)', fontWeight: 600, margin: 0, letterSpacing: '-0.01em', lineHeight: 1.1 }}>
              {bundleProduct.name}
            </h2>
            <p style={{ color: 'rgba(245,245,245,0.65)', fontSize: 14.5, lineHeight: 1.7, marginTop: 14 }}>
              {bundleProduct.tagline}
            </p>
            <div
              className="mono"
              style={{
                marginTop: 18,
                fontSize: 12,
                letterSpacing: '0.25em',
                color: '#f5f5f5',
                textTransform: 'uppercase',
              }}
            >
              ONE-TIME &middot; {bundleProduct.price}
            </div>
            <button onClick={goContact} className="btn-solid" style={{ marginTop: 22 }}>
              Request bundle
            </button>
          </div>
          <div>
            <div
              className="mono"
              style={{
                fontSize: 10,
                letterSpacing: '0.3em',
                color: 'rgba(245,245,245,0.5)',
                textTransform: 'uppercase',
                marginBottom: 14,
              }}
            >
              / What&apos;s inside
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', columnGap: 18, rowGap: 0 }}>
              <TickList items={bundleProduct.perks.slice(0, Math.ceil(bundleProduct.perks.length / 2))} />
              <TickList items={bundleProduct.perks.slice(Math.ceil(bundleProduct.perks.length / 2))} />
            </div>
          </div>
        </div>

        {/* All subscriptions grid */}
        <div style={{ marginTop: 56 }}>
          <div className="section-label" style={{ marginBottom: 18 }}>
            / Subscriptions & accounts
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
              gap: 20,
            }}
          >
            {allStoreProducts.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        </div>

        {/* Cyber tools */}
        <div style={{ marginTop: 72 }}>
          <div className="section-label" style={{ marginBottom: 18, display: 'flex', alignItems: 'center', gap: 10 }}>
            <Cpu size={12} /> / Cyber tools
          </div>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))',
              gap: 20,
            }}
          >
            {cyberProducts.map((p) => (
              <div key={p.id} className="glass-card" style={{ padding: 32, display: 'flex', flexDirection: 'column', gap: 18 }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <CyberChip size={64} />
                  <ShoppingBag size={16} strokeWidth={1.5} color="rgba(245,245,245,0.55)" />
                </div>
                <div>
                  <h3 style={{ fontFamily: 'Space Grotesk, sans-serif', fontWeight: 500, fontSize: 24, margin: 0, letterSpacing: '-0.01em' }}>
                    {p.name}
                  </h3>
                  <p style={{ color: 'rgba(245,245,245,0.6)', fontSize: 13.5, lineHeight: 1.6, margin: '6px 0 0' }}>{p.short}</p>
                </div>
                <TickList items={p.perks} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: 'auto', paddingTop: 16, borderTop: '1px solid rgba(245,245,245,0.06)' }}>
                  <button className="btn-ghost" style={{ padding: '8px 16px', fontSize: 10 }} onClick={goContact}>Request</button>
                </div>
              </div>
            ))}
          </div>
        </div>

        <ContactPromptCard message="Looking for something not listed? Drop me a message — I probably have it." />
      </div>
    </SubPageShell>
  );
}
